import React from 'react';
import PropTypes from 'prop-types';
import { StyleSheet, css } from 'aphrodite/no-important';
import { MAX_WIDTH, BASE_SPACING } from '../styles';

const s = StyleSheet.create({
  wrapper: {
    maxWidth: MAX_WIDTH,
    width: '100%',
    padding: `0 ${BASE_SPACING}px`,
    margin: '0 auto',
  },
});

const Wrapper = ({ __className, ...props }) => (
  <div {...props} className={css(s.wrapper, __className)} />
);

Wrapper.propTypes = {
  __className: PropTypes.any,
};

export default Wrapper;
